module.exports = __webpack_public_path__ + "ba7a2b690125723a53d7cc7b087782e1.svg";